import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    '&.marketplace': {
      width: '100%',
    },
  },

  wrapperField: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',

    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(30, 30, 30, 0.1)',
      top: 0,

      '& legend': {
        display: 'none',
      },
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(30, 30, 30, 0.3) !important',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(30, 30, 30, 0.7) !important',

      '& legend': {
        display: 'none',
      },
    },
    '& input': {
      color: '#1E1E1E',
      height: '19px',
    },
    '& label': {
      textOverflow: 'unset',
      whiteSpace: 'unset',
      color: 'rgba(30, 30, 30, 0.70)',
      backgroundColor: '#fff',
      padding: '0px 4px',
      [theme.breakpoints.up(3000)]: {
        fontSize: '25px',
      },
    },
    '& label.Mui-focused': {
      whiteSpace: 'nowrap',
      fontSize: '10px!important',
      backgroundColor: '#fff',
      top: '4px',
      transform: 'translate(16px, -10px)!important',
    },
  },
  errorText: {
    position: 'absolute',
    bottom: '-6px',
    right: '16px',
    lineHeight: '10px',
    padding: '2px 4px',
    backgroundColor: '#fff',
    fontSize: '10px',
    color: '#ED1C24',
    fontWeight: '500',
  },
  sendButton: {
    padding: '20px 10px',
  },
  isHidden: {
    display: 'none',
  },
}));
